import { makeRequest } from '../../../lib/api';

const VEHICLE_PATH = '/v1/catalog/vehicle';
const CLIENT_VEHICLE_PATH = '/v1/vehicles';

class vehiclesController {
  getVehicleMakes = (showDeleted = false) => {
    const showDeletedString = (showDeleted) ? '?showDeleted=true' : '';
    return makeRequest('get', `${ VEHICLE_PATH }/makes${ showDeletedString }`);
  };

  getVehicleModels = (makeId) => {
    return makeRequest('get', `${ VEHICLE_PATH }/makes/${ makeId }/models`);
  };

  getVehicleGenerations = (modelId) => {
    return makeRequest('get', `${ VEHICLE_PATH }/models/${ modelId }/generations`);
  };

  getVehicleModifications = (generationId) => {
    return makeRequest('get', `${ VEHICLE_PATH }/generations/${ generationId }/modifications`);
  };

  getClientVehicles = (data) => {
    return makeRequest('get', `${ CLIENT_VEHICLE_PATH }?clientId=${ data.clientId }&showDeleted=${ data.showDeleted || false }`);
  };

  getClientVehicle = (data) => {
    return makeRequest('get', `${ CLIENT_VEHICLE_PATH }/${ data.vehicleId }${ data.clientId ? `?clientId=${ data.clientId }` : '' }`);
  };

  postClientVehicle = (data) => {
    return makeRequest('post', `${ CLIENT_VEHICLE_PATH }?clientId=${ data.clientId }`, data);
  };

  putClientVehicle = (data) => {
    return makeRequest('put', `${ CLIENT_VEHICLE_PATH }/${ data.id }`, data);
  };

  makeClientVehiclePrimary = (data) => {
    return makeRequest('put', `${ CLIENT_VEHICLE_PATH }/${ data.vehicleId }/client/${ data.clientId }/primary`);
  };

  deleteClientVehicle = (vehicleId, clientId) => {
    return makeRequest('delete', `${ CLIENT_VEHICLE_PATH }/relations`, { vehicleId, clientId });
  };

  findVehicleByNumber = (number) => {
    return makeRequest('post', `${ CLIENT_VEHICLE_PATH }/find`, { number });
  };

  addVehicleToClient = (data) => {
    return makeRequest('post', `${ CLIENT_VEHICLE_PATH }/relations`, data);
  };

  getCarmenMakes = () => {
    return makeRequest('get', '/v1/vehicle_make_carmen');
  };

  updateCarmenMakes = (id, data) => {
    return makeRequest('put', `/v1/vehicle_make_carmen/${ id }`, data);
  };

  getVehicleOwners = (data) => {
    return makeRequest('get', `${ CLIENT_VEHICLE_PATH }/${ data.vehicleId }/clients?&showDeletedClients=${ data.showDeletedClients || false }&showDeletedRelations=${ data.showDeletedRelations || false }`);
  };

  getVehicleWheelDiameter = (vehicleId, { silentToast = false } = {}) => {
    return makeRequest(
      'get',
      `${ CLIENT_VEHICLE_PATH }/${ vehicleId }/wheel_diameter`,
      {},
      //{ apiBase: process.env.API2_URL, silentToast }
      { silentToast }
    );
  };
}

export default new vehiclesController();
